import { IntlProvider } from '@bbr/intl';
import { supportedLocales } from '@bbr/intl/locales';
import { getLocalTimeZone } from '@internationalized/date';
import langParser from 'accept-language-parser';
import { isServer, getRequestEvent } from 'solid-js/web';
import { useUser } from '../providers/user.tsx';
import type { ComponentProps, ParentProps } from 'solid-js';

const locales = import.meta.glob<false, string, { default: Record<string, string> }>('../messages/*.json', {
	import: 'default',
});

const fetcher: ComponentProps<typeof IntlProvider>['fetcher'] = async ({ locale }) => {
	const fileKey: keyof typeof locales | undefined = Object.keys(locales).find((messagePath) => {
		return new RegExp(`messages/${locale}\\.`).test(messagePath);
	});

	if (typeof fileKey === 'undefined') {
		return {};
	}

	return await locales[fileKey]!();
};

export function Intl(props: ParentProps) {
	const user = useUser();
	const req = getRequestEvent();
	const requested = langParser.pick(
		supportedLocales,
		!isServer
			? (document.documentElement.getAttribute('lang') ?? 'en')
			: (req?.request.headers.get('accept-language') ?? 'en'),
		{
			loose: true,
		},
	);

	return (
		<IntlProvider
			key="app"
			locale={req?.locals.locale ?? user()?.locale ?? requested ?? 'en'}
			units={user()?.units}
			fetcher={fetcher}
			timezone={getLocalTimeZone()}
		>
			{props.children}
		</IntlProvider>
	);
}
